module.exports = __webpack_public_path__ + "media/images/orange_money_logo-c4699bf5.jpeg";